<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[label]="step10.getdatejusquauvalidite"
[type]="'radio'" [rule]="''"
[value]="radioButtonValue"
[name]="getUid()+'_SepAtt_dateJusquauRB'"
[radios]="[
						{
                            value: '',
							label: step10.getjusquauvalidite
						},
                        {
                            value: 'duree',
							label: step10.getdureevalidite
						}
    ]"
>
</app-form-input>

<div *ngIf="!rbValue()">
<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="validite?.nbJours"
[label]="step10.getnbjoursvalidite"
[type]="'number'" [rule]="'min_1|max_9999'"
[name]="getUid()+'_SepAtt_nbJours'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="validite?.nbMois"
[label]="step10.getnbmoisvalidite"
[type]="'number'" [rule]="'min_1|max_999'"
[name]="getUid()+'_SepAtt_nbMois'">
</app-form-input>
</div>

<div *ngIf="rbValue()">
<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="validite?.dateJusquau"
[label]="step10.getjusquauvalidite"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateJusquau'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
</div>
